import(/* webpackMode: "eager" */ "/vercel/path0/src/app/insights/page.tsx");
